import { buffers, eventChannel } from 'redux-saga'
import { call, fork } from 'redux-saga/effects'

import assert from './assert'
import { syncChannel } from './utils'
import { doc, addDoc, getDoc, setDoc,updateDoc, getDocs, collection,onSnapshot,query } from "@firebase/firestore";

export const getCollectionRef = (rsf, pathOrRef) => {
  assert(
    !!rsf.fs,
    "Firestore isn't installed. " +
      "Did you forget to `import '@firebase/firestore'`? " +
      'See https://redux-saga-firebase.js.org/ for more information.',
  )

  return typeof pathOrRef === 'string'
    ? collection(rsf.fs, pathOrRef)
    : pathOrRef
}

export const getDocumentRef = (rsf, pathOrRef) => {
  assert(
    !!rsf.fs,
    "Firestore isn't installed. " +
      "Did you forget to `import '@firebase/firestore'`? " +
      'See https://redux-saga-firebase.js.org/ for more information.',
  )

  return typeof pathOrRef === 'string' ? doc(rsf.fs, pathOrRef) : pathOrRef
}

function* addDocument(collectionRef, data) {
  const collection = getCollectionRef(this, collectionRef)
  // return yield call([collection, collection.add], data)
  return yield call(addDoc, collection, data)
}

function channel(
  pathOrRef,
  type = 'collection',
  buffer = buffers.none(),
  snapshotListenOptions,
) {
  
  const ref =
    type === 'collection'
      ? getCollectionRef(this, pathOrRef)
      : getDocumentRef(this, pathOrRef)

  const channel = eventChannel(emit => {
    const unsubscribe = snapshotListenOptions
      ? onSnapshot(ref, snapshotListenOptions, emit)
      : onSnapshot(ref, emit)

    // Returns unsubscribe function
    return unsubscribe
  }, buffer)

  return channel
}

function* deleteDocument(documentRef) {
  const doc = getDocumentRef(this, documentRef)
  return yield call([doc, doc.delete])
}

function* getCollection(collectionRef, query) {
  const colRef = getCollectionRef(this, collectionRef)
  // return yield call([collection, collection.get])
  return yield call(getDocs, query(colRef, ...query))
}

function* getDocument(documentRef) {
  const doc = getDocumentRef(this, documentRef)
  // return yield call([doc, doc.get])
  return yield call(getDoc, doc)
}

function* setDocument(documentRef, data, options) {
  const doc = getDocumentRef(this, documentRef)
  // return yield call([doc, doc.set], data, options)
  return yield call(setDoc, doc, data, options)
}

function* updateDocument(documentRef, ...args) {
  const doc = getDocumentRef(this, documentRef)
  // @ts-ignore
  // return yield call([doc, doc.update], ...args)
  return yield call(updateDoc, doc, ...args)
}

function* syncCollection(pathOrRef, options) {
  const channel = yield call(
    this.firestore.channel,
    pathOrRef,
    'collection',
    undefined,
    options.snapshotListenOptions,
  )
  yield fork(syncChannel, channel, options)
}

function* syncDocument(pathOrRef, options) {
  const channel = yield call(
    this.firestore.channel,
    pathOrRef,
    'document',
    undefined,
    options.snapshotListenOptions,
  )
  yield fork(syncChannel, channel, options)
}

export default {
  addDocument,
  channel,
  deleteDocument,
  getCollection,
  getDocument,
  setDocument,
  syncCollection,
  syncDocument,
  updateDocument,
}
